import { useState, useEffect } from "react";
import {
  Popover,
  Button,
  Checkbox,
  Input,
  Table,
  message,
  Tooltip,
} from "antd";
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import DeleteIcon from "../../../Assets/deletes.svg";
import EditIcon from "../../../Assets/eye.svg";
import AssignIcon from "../../../Assets/assig.svg";
import API_MANAGER from "../../../API";
import { ShowHideTransferModal } from "./ShowHideTransferModal";
import DeleteGateModal from "./DeleteGateModal";

const ShowHideColumnsPopover = ({
  columnsvisible,
  toggleVisibility,
  setmobilzationColumn,
  sethidecolumn,
  sethideRow,
  hidecolumn,
  setSelectedGates,
  hideRow,
  rowData,
  advertId,
  advertIdsfinal,
  setRefreshToggle,
  setTransferModal,
  transferModal,
  candidateSelectedData,
  oldAdvertId,
  profileId,
  candidateName,
  setReloadState,
  setfilterDataAdvert,
  setCurrentPage,
  transferData,
  search,
  setSearch,
  setadvertIds,
  advertIds,
  handleAddMannualPopulatedGates,
  handleToggle,
  setSelectedRowKeys,
  handleDeleteSubmit,
  setPrevGateName,
  handeldeleteRow,
  isArchiveView,
}) => {
  const validColumns = Array.isArray(setmobilzationColumn)
    ? setmobilzationColumn
    : [];

  const LOCAL_STORAGE_KEY = "hiddenColumnsState";
  const LOCAL_STORAGE_KEY1 = "hiddenColumnsStateCheck";
  const HIDDEN_ROWS_KEY = "hiddenRowsState";

  const [visible, setVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [colGateId, setcolGateId] = useState();
  // const [gateName,setGateName]=useState();

  const [selectedColumnsCheck, setSelectedColumnsCheck] = useState([]);

  const [selectedHiddenRows, setSelectedHiddenRows] = useState([]);
  

  const [selectedHiddenJobIds, setSelectedHiddenJobIds] = useState([]);

  const [prefilledAdvertIds, setprefilledAdvertIds] = useState([]);

  const [deleteGateModal, setDeleteGateModal] = useState(false);
  const [gateToDelete, setGateToDelete] = useState(null);
  const [hiddenGatesToDelete, setHiddenGatesToDelete] = useState([]);

  const [openModals, setopenModals] = useState(false);

  useEffect(()=>{
    if(!visible){
      setSelectedHiddenRows([])

   
      setSelectedHiddenJobIds([])
      setcolGateId();
    }
  },[visible])

  const assignGates = async () => {
    try {
      const data = {
        adverts: advertIds,
        gates: colGateId,
      };

      const response = await API_MANAGER.assignGates(data);
      // setGateValue(response?.data?.data?.gateValue);
      // console.log(response?.data?.data?.gateValue, "TEST RESP");

      if (response?.status === 200) {
        message.success("Gate(s) successfully assigned.");
        setVisible(false);
        handleToggle();

        // setIsAddGateModalOpen(false);
      } else {
        message.error(JSON.stringify(response?.data?.message, null, 2));
        // setSelectedColumns();
      }
    } catch (error) {
      message.error(JSON.stringify(error?.response?.data?.message, null, 2));
      // setSelectedColumns();
    }
  };

  const handelAdvertofGates = async () => {
    const gateName = selectedHiddenRows.map((row) => {
      return row.dataIndex;
    });
    try {
      const data = {
        gateNames: gateName,
      };

      const response = await API_MANAGER.getadvertsOfGates(data);
      setprefilledAdvertIds(response?.data?.data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    const storedColumns1 = localStorage.getItem(LOCAL_STORAGE_KEY);
    const storedColumns2 = localStorage.getItem(LOCAL_STORAGE_KEY1);

    let mergedColumns = [];

    try {
      const parsed1 = storedColumns1 ? JSON.parse(storedColumns1) : [];
      const parsed2 = storedColumns2 ? JSON.parse(storedColumns2) : [];

      // Merge both arrays and remove duplicates if needed
      mergedColumns = Array.from(new Set([...parsed1, ...parsed2]));

      setSelectedColumns(mergedColumns);
      sethidecolumn(mergedColumns);
    } catch (e) {
      console.error("Failed to parse column state from localStorage", e);
    }
  }, []);

  useEffect(() => {
    const storedHiddenRows = localStorage.getItem(HIDDEN_ROWS_KEY);
    if (storedHiddenRows) {
      try {
        const parsedHiddenRows = JSON.parse(storedHiddenRows);
        if (Array.isArray(parsedHiddenRows)) {
          sethideRow(parsedHiddenRows);
        }
      } catch (e) {
        console.error("Failed to parse hidden rows from localStorage", e);
      }
    }
  }, []);
  useEffect(() => {
    localStorage.setItem(HIDDEN_ROWS_KEY, JSON.stringify(hideRow));
  }, [hideRow]);

  const filteredRowData = Array.isArray(hideRow)
    ? rowData.filter((row) => hideRow.includes(row.jobId))
    : [];

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(selectedColumns));
  }, [selectedColumns]);
  useEffect(() => {
    localStorage.setItem(
      LOCAL_STORAGE_KEY1,
      JSON.stringify(selectedColumnsCheck)
    );
  }, [selectedColumnsCheck]);

  const handleCheckboxToggle = (dataIndex) => {
    const updatedSelection = selectedColumns.includes(dataIndex)
      ? selectedColumns.filter((col) => col !== dataIndex)
      : [...selectedColumns, dataIndex];

    setSelectedColumns(updatedSelection);
    sethidecolumn(updatedSelection);
    // {
    //   selectedColumns.length > 0 &&
    //     message.success("Selected column have been hidden");
    // }
  };

  const handleRowToggle = (dataIndex) => {
    const updatedSelection = hideRow.includes(dataIndex)
      ? hideRow.filter((col) => col !== dataIndex)
      : [...hideRow, dataIndex];
    // setSelectedRows(updatedSelection);
    // setSelectedHiddenJobIds(updatedSelection);
    sethideRow(updatedSelection);
  };

  const filteredColumns = validColumns.filter(
    (col) =>
      col.dataIndex.toLowerCase() !== "details" &&
      col.dataIndex.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columnDeleteHandel = (gateName, selectedHiddenGate) => {
    setGateToDelete(gateName);
    setHiddenGatesToDelete(selectedHiddenGate || []);
    setDeleteGateModal(true);
  };

  const handelDelete = async () => {
    let param;

    if (gateToDelete) {
      param = {
        adverts: advertIdsfinal,
        gates: [gateToDelete],
      };
    } else {
      param = {
        adverts: advertIdsfinal,
        gates: hiddenGatesToDelete.map((gates) => gates.dataIndex),
      };
    }

    try {
      const response = await API_MANAGER.bulkGateDelete(param);
      setSelectedHiddenRows([]);
      setRefreshToggle();
      setVisible(false);
      setDeleteGateModal(false);
      message.success("Gate(s) successfully removed.");
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const formatLabel = (dataIndex) => {
    if (["lsl", "ppe", "dob"].includes(dataIndex)) {
      return dataIndex.toUpperCase();
    }
    if (dataIndex.toLowerCase() === "nok") {
      return "Next-of-kin";
    }
    return dataIndex.charAt(0).toUpperCase() + dataIndex.slice(1);
  };

  const bulkHide = () => {
    const updatedhidencolumn = [...hidecolumn];
    const spreadedhidencolumn = selectedHiddenRows.map(
      (gates) => gates.dataIndex
    );
    spreadedhidencolumn.forEach((item) => {
      const index = updatedhidencolumn.indexOf(item);
      if (index > -1) {
        updatedhidencolumn.splice(index, 1);
      } else {
        updatedhidencolumn.push(item);
      }
    });
    setSelectedColumns(updatedhidencolumn);
    sethidecolumn(updatedhidencolumn);
  };

  const bulkHideRow = () => {
    const selectedRows = [...hideRow];
    const spreadedhidenrow = [...selectedHiddenJobIds];

    spreadedhidenrow.forEach((item) => {
      const index = selectedRows.indexOf(item);
      if (index > -1) {
        selectedRows.splice(index, 1);
      } else {
        selectedRows.push(item);
      }
    });
    // setSelectedHiddenJobIds(selectedRows);
    sethideRow(selectedRows);
  };

  const content = (
    <div
      className="show-hide-content"
      style={{
        display: "flex",
        gap: "10px",
        width: 500,
        padding: 10,
        background: "#fff",
        borderRadius: 8,
      }}
    >
      {/* Shared Search */}
      <div className="show-hide-search-header" style={{ position: "absolute", top: 10, left: 10, right: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "space-between",
          }}
        >
          <h4
            style={{ fontSize: 14, fontWeight: 600, color: "black", margin: 0 }}
          >
            Show/Hide Gates & Profiles
          </h4>

          {/* Your three icons */}
          <div
            style={{
              display: "flex",
              gap: "6px",
            }}
          >
            <div
              onClick={() => {
                if (selectedHiddenRows.length > 0) {
                  columnDeleteHandel(null, selectedHiddenRows);
                  setVisible(false);
                  // handelDelete(null, selectedHiddenRows);
                } else if (selectedHiddenJobIds.length > 0) {
                  handeldeleteRow(selectedHiddenJobIds);
                  setVisible(false);
                }
              }}
              style={{
                backgroundColor: "#FFE5E5",
                padding: "6px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <img src={DeleteIcon} alt="Delete" width="18" height="18" />
            </div>
            <div
              style={{
                backgroundColor: "#E5EDFF",
                padding: "6px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                bulkHide();
                bulkHideRow();
             setVisible(false);
              
              }}
            >
              <img src={EditIcon} alt="Hide" width="18" height="18" />
            </div>

            <Tooltip
              title={
                selectedHiddenJobIds.length > 0
                  ? "Unselect rows to enable assign"
                  : ""
              }
            >
              <div
                onClick={() => {
                  if (selectedHiddenRows.length > 0) {
                    handelAdvertofGates();
                    if (selectedHiddenJobIds.length === 0) {
                      setopenModals(true);
                    }
                  }
                }}
                style={{
                  backgroundColor:
                    selectedHiddenJobIds.length != 0 ||
                    selectedHiddenRows.length === 0
                      ? "#BBBBBB"
                      : "#0047FF",
                  padding: "6px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor:
                    selectedHiddenJobIds.length === 0 ||
                    selectedHiddenRows.length === 0
                      ? "pointer"
                      : "not-allowed",
                }}
              >
                <img src={AssignIcon} alt="Add" width="18" height="18" />
              </div>
            </Tooltip>
          </div>
        </div>

        {/* Search Box */}
        <Input
          placeholder="Search hidden gates or hidden profiles"
          style={{ marginTop: 8, marginBottom: 16 }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          allowClear
        />
      </div>

      <div className="show-hide-column" style={{ width: "50%", paddingTop: 70 }}>
        <h4
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "black",
            marginTop: "10px",
          }}
        >
          HIDDEN GATES
        </h4>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          {filteredColumns.length > 0 ? (
            [...filteredColumns]
              .sort((a, b) => a.dataIndex.localeCompare(b.dataIndex))
              .map((col) => (
                <div
                  key={col.dataIndex}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "4px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Checkbox
                      disabled={col.dataIndex === "campaign-advert"}
                      style={
                        col.dataIndex === "campaign-advert"
                          ? {
                              opacity: 0.3,
                              backgroundColor: "#f5f5f5",
                              borderColor: "d9d9d9",
                              cursor: "not-allowed",
                              // Add any other grey-out styles you prefer
                            }
                          : {}
                      }
                      checked={selectedHiddenRows.some(
                        (item) => item.dataIndex === col.dataIndex
                      )}
                      onChange={(e) => {
                        const isChecked = e.target.checked;

                        const updatedSelection = isChecked
                          ? [
                              ...selectedHiddenRows,
                              { dataIndex: col.dataIndex, gateId: col.gateId },
                            ]
                          : selectedHiddenRows.filter(
                              (item) => item.dataIndex !== col.dataIndex
                            );
                        setSelectedHiddenRows(updatedSelection);
                        const gateIds = updatedSelection.map(
                          (item) => item.gateId
                        );
                        setcolGateId(gateIds);
                      }}
                    ></Checkbox>

                    {selectedColumns.includes(col.dataIndex) ? (
                      <EyeInvisibleOutlined
                        style={{ color: "#BBBBBB", cursor: "pointer" }}
                        onClick={() => handleCheckboxToggle(col.dataIndex)}
                      />
                    ) : (
                      <EyeOutlined
                        style={{
                          color: "#1890ff",
                          cursor: "pointer",
                        }}
                        onClick={() => handleCheckboxToggle(col.dataIndex)}
                      />
                    )}

                    <span
                      style={{
                        color: selectedColumns.includes(col.dataIndex)
                          ? "#BBBBBB"
                          : "black",
                      }}
                    >
                      {["lsl", "ppe", "dob"].includes(col.dataIndex)
                        ? col.dataIndex.toUpperCase()
                        : ["usi", "usi_number", "usi number"].includes(
                            col.dataIndex.toLowerCase().replace(/[_\s]/g, " ")
                          )
                        ? "USI number"
                        : col.dataIndex.toLowerCase() === "nok"
                        ? "Next-of-Kin"
                        : col.dataIndex.charAt(0).toUpperCase() +
                          col.dataIndex.slice(1)}
                    </span>
                  </div>

                  {col.dataIndex !== "campaign-advert" && (
                    <div style={{ display: "flex", gap: "8px" }}>
                      <CloseOutlined
                        style={{ color: "#ff4d4f", cursor: "pointer" }}
                        onClick={() => {
                          columnDeleteHandel(col.dataIndex);
                          setVisible(false);
                        }}
                      />
                    </div>
                  )}
                </div>
              ))
          ) : (
            <div style={{ textAlign: "center", color: "#999" }}>
              No matching columns
            </div>
          )}
        </div>
      </div>

      <div className="show-hide-column" style={{ width: "50%", paddingTop: 70 }}>
        <h4
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "black",
            marginTop: "10px",
          }}
        >
          HIDDEN PROFILES
        </h4>
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          {(rowData || []).filter((row) => {
            const displayText = `${row.userName} `;
            return displayText.toLowerCase().includes(searchTerm.toLowerCase());
          }).length > 0 ? (
            (rowData || []).map((row) => {
              const displayText = `${row.userName} `;
              const matchesSearch = displayText
                .toLowerCase()
                .includes(searchTerm.toLowerCase());

              if (!matchesSearch) return null;

              return (
                <div
                  key={row.jobId}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "4px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Checkbox
                   checked={selectedHiddenJobIds.includes(row.jobId)}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const updatedSelection = isChecked
                          ? [...selectedHiddenJobIds, row.jobId]
                          : selectedHiddenJobIds.filter(
                              (id) => id !== row.jobId
                            );

                        setSelectedHiddenJobIds(updatedSelection);

                        const gateIds = updatedSelection.map(
                          (item) => item.gateId
                        );
                        setcolGateId(gateIds);
                      }}
                    />

                    {hideRow.includes(row?.jobId) ? (
                      <EyeInvisibleOutlined
                        style={{ color: "#BBBBBB", cursor: "pointer" }}
                        onClick={() => handleRowToggle(row.jobId)}
                      />
                    ) : (
                      <EyeOutlined
                        style={{
                          color: "#1890ff",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRowToggle(row.jobId)}
                      />
                    )}
                    <span
                      style={{
                        color: hideRow.includes(row.jobId)
                          ? "#BBBBBB"
                          : "black",
                      }}
                    >
                      {displayText}
                    </span>
                  </div>

                  <div style={{ display: "flex", gap: "8px" }}>
                    <CloseOutlined
                      style={{ color: "#ff4d4f", cursor: "pointer" }}
                      onClick={() => {
                        // setSelectedRowKeys(row.jobId);
                        handeldeleteRow(row.jobId);
                        setVisible(false);
                      }}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: "center", color: "#999" }}>
              No matching hidden rows
            </div>
          )}
        </div>
      </div>
    </div>
  );
  const handlePopoverVisibility = (newVisible) => {
    setTimeout(() => {
      if (!openModals) {
        setVisible(newVisible);
      }
    }, 100);
  };

  return (
    <>
      <Popover
        content={content}
        trigger="click"
        placement="bottomRight"
        open={visible}
        onOpenChange={(v) => {
          if (isArchiveView) return; // block opening in archive view
          handlePopoverVisibility(v);
        }}
        overlayInnerStyle={{
          backgroundColor: "#fff !important",
          padding: "0px",
        }}
        overlayClassName="show-hide-popover"
        // onOpenChange={handlePopoverVisibility}
        maskClosable={openModals}
        overlayStyle={{ outline: "none" }}
      >
        <Button
          disabled={isArchiveView}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            background: isArchiveView ? "#F5F5F5" : "#F8FAFC",
            border: isArchiveView ? "1px solid #D9D9D9" : "1px solid #E2E8F0",
            borderRadius: "8px",
            padding: "20px 12px",
            fontSize: "14px",
            fontWeight: "500",
            color: isArchiveView ? "#BBBBBB" : "#64748B",
            cursor: isArchiveView ? "not-allowed" : "pointer",
            boxShadow: isArchiveView ? "none" : "0px 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "28px",
              height: "28px",
              background: isArchiveView ? "#F0F0F0" : "#EEF4FF",
              borderRadius: "6px",
            }}
          >
            <EyeInvisibleOutlined
              style={{ fontSize: "16px", color: isArchiveView ? "#A0A0A0" : "#1638B1" }}
            />
          </div>
          Show/Hide
        </Button>
        <ShowHideTransferModal
          assignGates={assignGates}
          prefilledAdvertIds={prefilledAdvertIds}
          transferModal={openModals}
          setTransferModal={setopenModals}
          candidateSelectedData={candidateSelectedData}
          oldAdvertId={oldAdvertId}
          profileId={profileId}
          candidateName={candidateName}
          setReloadState={setReloadState}
          setfilterDataAdvert={setfilterDataAdvert}
          transferData={transferData}
          search={search}
          setSearch={setSearch}
          setadvertIds={setadvertIds}
          advertIds={advertIds}
          handleAddMannualPopulatedGates={handleAddMannualPopulatedGates}
        />
      </Popover>
      <DeleteGateModal
        visible={deleteGateModal}
        setVisible={setDeleteGateModal}
        text={"Gate"}
        handleSubmit={handelDelete}
      />
    </>
  );
};

export default ShowHideColumnsPopover;
